/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/*
// Author: Grin Zhou
*/


import React from 'react';
import PropTypes from 'prop-types';
import './style.css'

const ErrorAtTop = (props) => {
    const { content, isDisplay } = props;
    const showClz = isDisplay ? 'on' : '';

    if (isDisplay) {
        return (
            <div className={`error-at-top clearfix ${showClz}`}>
                <i aria-hidden={true} className="icon icon-triangle-error">{}</i>
                <article aria-live="polite">
                    <h4 data-key={ 'errorAtTop.errorTitle' }>{ content.errorTitle }</h4>
                    { content.errorInfo &&
                    <p className="font-body1" data-key={ 'errorAtTop.errorInfo' }>
                        { content.errorInfo }
                    </p>
                    }
                </article>
            </div>
        );
    }

    return null;
};

ErrorAtTop.propTypes = {
    content: PropTypes.object.isRequired,
    isDisplay: PropTypes.bool
};

ErrorAtTop.defaultProps = {
    content: {},
    isDisplay: false
};

export default ErrorAtTop;



// WEBPACK FOOTER //
// ./src/shared/AOForm/components/ErrorAtTop/index.js